<template>
  <modal :show.sync="modalOpen" bodyClasses="pt-0 pb-0">
      <h2
        slot="header"
        class="modal-title"
        id="modal-title-default"
      >
        Create Team
      </h2>

      <base-alert type="danger" v-if="errors.players">
        {{errors.players}}
      </base-alert>

      <div class="row">
        <div class="col">
          <base-input
            alternative=""
            label="Team Name"
            placeholder="Team Name"
            input-classes="form-control-alternative"
            v-model="model.teamName"
            :error="errors.teamName"
          />
        </div>
      </div>

      <div class="row" v-if="league.divisions && league.divisions.length > 0">
        <div class="col">
          <base-input
            label="Division"
          >
            <Multiselect
              v-model="model.division"
              :options="league.divisions"
              class="shadow"
              track-by="id"
              label="name"
            />
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <base-input
            label="Add Player"
            :error="errors.selectedPlayer"
          >
            <Multiselect
              v-model="model.selectedPlayer"
              :options="playerSearchOptions"
              class="shadow"
              track-by="id"
              label="Name"
              @search-change="searchUsers"
              :internal-search="false"
            >
              <template slot="option" slot-scope="props">
                <div class="row">
                  <div class="col-2">
                    <img class="avatar" :src="getAvatarUrl(props.option)" />
                  </div>
                  <div class="col-auto">
                    <h4>{{props.option.Name}}</h4>
                    <span class="email">{{props.option.email}}</span>
                  </div>
                </div>
              </template>
              <template slot="afterList">
                <div
                  class="new-player-option"
                  @click="addPlayerToTeam"
                >
                  + Create New Player
                </div>
              </template>
              <template slot="noResult">
                <div class="pt-1 pb-1">
                  No players found.
                </div>
              </template>
              <template slot="noOptions">
                <div class="pt-1 pb-1">
                  No players found.
                </div>
              </template>
            </Multiselect>
          </base-input>
        </div>
        <div class="col-2 align-bottom">
          <base-button
            type="info"
            @click="addPlayerToTeam"
          >
            +
          </base-button>
        </div>
      </div>

      <div class="row" v-if="model.players.length > 0">
        <div class="col-12">
          <label class="form-control-label">
            Players
          </label>
        </div>
        <div
          class="col-12 team-player-row"
          v-for="(player, index) in model.players"
          :key="index"
        >
          <TeamPlayerCard
            v-model="model.players[index]"
            @onRemove="removePlayerFromTeam(index)"
            ref="playerCard"
          />
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="primary"
          @click="addTeam"
        >
          Add Team
        </base-button>
        <base-button
          type="link"
          class="ml-auto"
          @click="$emit('close')"
        >
          Cancel
        </base-button>
      </template>
    </modal>
</template>
<script>
import Multiselect from 'vue-multiselect';
import Fuse from 'fuse.js';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import AvatarHelper from '@/helpers/Avatars.js';
import TeamPlayerCard from '@/components/TeamPlayerCard.vue';
import ErrorHandler from '@/helpers/AuthError';

export default {
  name: 'AddTeamModal',
  props: {
    open: Boolean,
    league: Object,
  },
  components: {
    Multiselect,
    TeamPlayerCard,
  },
  data() {
    return {
      model: {
        teamName: '',
        players: [],
        selectedPlayer: null,
        name: '',
        email: '',
        paidInFull: false,
        paidDeposit: false,
        division: null,
      },
      errors: {
        teamName: '',
        name: '',
        email: '',
        selectedPlayer: '',
        division: '',
      },
      playerSearchOptions: [],
      removedPlayers: [],
    };
  },
  mounted() {
    this.$store.dispatch('getPlayers');
    this.$store.dispatch('getTeams');
    if (this.teamId) {
      this.getTeam();
    }
  },
  computed: {
    allPlayers() {
      return this.$store.state.players;
    },
    allTeams() {
      return this.$store.state.teams;
    },
    modalOpen: {
      get() {
        return this.open;
      },
      set() {
        this.$emit('close');
      },
    },
    searchSet() {
      // exclude players in league
      const searchSet = [];
      const leagueTeamIds = this.league.teams.map(team => team.id);

      let leaguePlayerIds = [];
      this.allTeams.forEach((team) => {
        if (leagueTeamIds.includes(team.id)) {
          leaguePlayerIds = leaguePlayerIds.concat(team.player_profiles.map(player => player.user));
        }
      });

      this.allPlayers.forEach((player) => {
        if (!leaguePlayerIds.includes(player.id)) {
          searchSet.push(player);
        }
      });

      return searchSet;
    },
  },
  methods: {
    checkForSubmissionErrors() {
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          this.errors[key] = '';
        }
      });
      if (this.model.teamName === '') {
        this.errors.teamName = 'This field is required';
      }
      if (this.model.players.length <= 0) {
        this.errors.players = 'Teams require at least one player';
      }
      if (this.model.division === null && this.league.divisions.length > 0) {
        this.errors.divisions = 'Teams must be assigned to a division';
      }
      this.$refs.playerCard.forEach((card) => {
        console.log(card.errors);
        if (card.hasError) {
          this.errors.players = 'One or more players are missing a field';
        }
      });
    },
    addTeam() {
      this.checkForSubmissionErrors();
      let isOk = true;

      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          isOk = false;
        }
      });

      console.log('ERRORS', this.errors);

      if (!isOk) {
        return;
      }

      console.log('Past the error phase');

      const newTeamPlayers = [];
      const createUserJobs = [];

      this.model.players.forEach((player) => {
        if (player.id) {
          newTeamPlayers.push({
            id: player.id,
            paidInFull: player.paidInFull,
            tooniePot: player.tooniePot,
          });
        } else {
          createUserJobs.push(this.createUser({
            Name: player.Name,
            email: player.email,
            username: player.email,
            confirmed: true,
            password: player.email,
            paidInFull: player.paidInFull,
            tooniePot: player.tooniePot,
          }));
        }
      });

      Promise.all(createUserJobs)
        .then((newUsers) => {
          newUsers.forEach((result) => {
            newTeamPlayers.push({
              id: result.player.id,
              paidInFull: result.paidInFull,
              tooniePot: result.tooniePot,
            });
          });

          const playerProfileJobs = [];
          newTeamPlayers.forEach((player) => {
            playerProfileJobs.push(this.addTeamProfile(player.id, player.paidInFull, player.tooniePot));
          });

          return Promise.all(playerProfileJobs);
        })
        .then((newProfiles) => {
          const newTeam = {
            Name: this.model.teamName,
            player_profiles: newProfiles,
            league: this.league.id,
            division: this.model.division ? this.model.division.id : null,
          };
          return this.axios.post('/teams', newTeam, {
            headers: {
              Authorization: `Bearer ${this.$store.state.authToken}`,
            },
          });
        })
        .then((response) => {
          this.model.players = [];
          this.model.teamName = '';
          this.model.division = null;
          this.$emit('close');
          this.$store.dispatch('getPlayers');
          this.$store.dispatch('getTeams');
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    addTeamProfile(userId, paidInFull, tooniePot) {
      const newProfile = {
        user: userId,
        paidInFull: paidInFull === 'full',
        paidDeposit: paidInFull === 'deposit',
        tooniePot,
      };

      return this.axios
        .post('/teamprofiles', newProfile, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(response => response.data)
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    deleteTeamProfile(profileId) {
      return this.axios
        .delete(`/teamprofiles/${profileId}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(response => response.data)
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    createUser(newUser) {
      console.log(newUser);
      return this.axios
        .post('/users', newUser, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);

          return { player: response.data, paidInFull: newUser.paidInFull };
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    searchUsers(input) {
      if (input === '') {
        this.playerSearchOptions = this.searchSet;
      }
      const options = {
        keys: ['Name', 'email', 'username', 'id'],
      };

      const fuse = new Fuse(this.searchSet, options);

      const result = fuse.search(input);

      this.playerSearchOptions = result;
    },
    removePlayerFromTeam(index) {
      this.removedPlayers.push(this.model.players[index]);
      this.model.players.splice(index, 1);
    },
    addPlayerToTeam() {
      if (this.model.selectedPlayer !== null) {
        this.model.players.push({
          ...this.model.selectedPlayer,
          paidInFull: '',
          tooniePot: false,
        });
        this.model.selectedPlayer = null;
      } else {
        this.model.players.push({
          Name: '',
          email: '',
          avatar: '',
          paidInFull: '',
          tooniePot: false,
          id: '',
        });
      }
    },
    getAvatarUrl(user) {
      return AvatarHelper.getAvatar(user);
    },
  },
};
</script>
<style lang="scss">
  .multiselect{
    min-height: 43px;
    box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02) !important;
    border: 0 !important;
    border-radius: 0.375rem;

    .multiselect__tags{
      min-height: 43px;
      padding-top: 12px;
      border: 0;
      color:#8898aa;
    }

    .multiselect__select{
      padding-top: 13px;
    }
  }
  .avatar{
    object-fit: cover;
  }

  .align-bottom{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 1.5rem;
  }

  .player-remove-icon{
    margin-left: 1rem;
  }

  .team-player-row{
    margin-bottom: .5rem;
    &:last-child{
      margin-bottom: 0;
    }
  }
</style>
